__turbopack_context__.v({
  "hero": "Hero-module-scss-module__8hH3ya__hero",
  "hero__content": "Hero-module-scss-module__8hH3ya__hero__content",
  "hero__cta": "Hero-module-scss-module__8hH3ya__hero__cta",
  "hero__headline": "Hero-module-scss-module__8hH3ya__hero__headline",
  "hero__pill": "Hero-module-scss-module__8hH3ya__hero__pill",
  "hero__subcopy": "Hero-module-scss-module__8hH3ya__hero__subcopy",
});
